import { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import MRegistroVentaTienda from "@VentaEnTienda/Modales/MRegistroVentaTienda";

//MRegistroVentaTienda
import * as _testing_ from "@Funciones/testing";
import "./VentaEnTienda.css";

function VentaEnTienda() {
  const origenComponente = "VentaEnTienda";
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [recargaComponente,erecargaComponente] = useState(false)
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    do_datosTabla: {},
    do_filtros: {},
    do_seleccionados: {},
    da_precioDeVenta: [
      { id: "1", valor: "Tienda" },
      { id: "2", valor: "Distribuidor" },
      { id: "3", valor: "Personal" },
    ],
    d_codigoPrecioDeVenta: "1",
    d_actualizarTabla: false,
    d_totalEntrega: 0,
    d_tipoComprobante: "",
    d_codigoPedido: 0,
    d_comentario: "",
    d_codigoComprobante: 3,
    d_esperandoProcesoTabla: false
  });

  useEffect(() => {
    const pedidoTienda = _api_.f_pedidoTienda({
      parametros: {
        codUsuario: v_u.d_codigoPrecioDeVenta,
        tipoDistribucion: 1,
      },
      origen: origenComponente,
      timeout: 15000,
    });
    pedidoTienda.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          do_datosTabla: dPC.contenido,
          d_totalEntrega: dPC.contenido.totalEntrega,
          d_codigoPedido: dPC.contenido.codPedido,
        });
      }
      _f_.asignar(ev_u, { i_procesandoApiCarga: false });
    });
  }, [v_u.d_codigoPrecioDeVenta, v_u.d_actualizarTabla,recargaComponente]);

  useEffect(() => {
    //console.log(v_u.do_filtros);
    //console.log(v_u);
    console.log(v_u.do_seleccionados);
    //console.log(cv_u);
  }, [v_u.do_seleccionados, v_u.do_filtros]);

  useEffect(() => {
    //console.log(v_u.do_filtros);
    //console.log(v_u);
    //console.log(v_u.do_seleccionados);
    //console.log(cv_u);
  }, [cv_u]);

  if (v_u.i_procesandoApiCarga) return <_anim_.SpinnerHTML estilos={{ height: "5rem", color: "green" }} />;

  //if (cv_u.error) return <div>error</div>;

  return (
    <div className="ventaEnTiendaCSS-contenedor">
      {v_c.modal_mostrar && (
        <ModalInformacion
          titulo={v_c.modal_titulo}
          estilos={v_c.modal_estilos}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
            });
          }}>
          <MRegistroVentaTienda
            origenComponente
            fActualizarTablaTotal={(actualizo)=>{
              if(actualizo){
                erecargaComponente((prev)=>!prev)
              }
              
            }}
            fCerrarComponente={() => {
              _f_.asignar(ev_c, {
                modal_mostrar: false,
              });
            }}
            parametros={{
              tipoComprobante: v_u.d_tipoComprobante,
              totalEntrega: v_u.d_totalEntrega,
              precioVenta: v_u.d_codigoPrecioDeVenta, //codUsuario
              codigoPedido: v_u.d_codigoPedido, //codPedido
              comentario: v_u.d_comentario,
              codigoComprobante: v_u.d_codigoComprobante,
            }}
          />
        </ModalInformacion>
      )}
      <div className="titulo-componente">{"Venta en Tienda"}</div>
      <div className="ventaEnTiendaCSS-cabecera">
        <_div_.Div2
          texto={`Total: ${_f_.formatearValor({
            valor: v_u.d_totalEntrega,
            moneda: "PEN",
            precision: 2,
            tipo: "moneda",
          })}`}
        />
        <_ipt_.Input4
          tipo="date"
          defaultValue={_f_.fechaActual({ formato: "yyyy-mm-dd" })}
          texto="Fecha Actual"
          estilos={{ flexGrow: 0, width: "100%" }}
          disabled
        />
        <_opt_.Opcion2
          texto="Precio de Venta"
          clave={["id"]}
          valor={["valor"]}
          opciones={v_u.da_precioDeVenta || []}
          name={"wefwfwefwef"}
          estilos={{ flexGrow: 1, width: "100%" }}
          seleccionado={v_u.d_codigoPrecioDeVenta}
          onBlur={(evento) => {
            const codigoPrecioVenta = evento.target.getAttribute("value");
            if (codigoPrecioVenta !== "") {
              _f_.asignar(ev_u, {
                d_codigoPrecioDeVenta: codigoPrecioVenta,
              });
            }
            //console.log(evento.target.getAttribute("value"));
          }}
        />
      </div>
      {
        <Filtros
          filtros={v_u.do_datosTabla.filtros}
          funcionObtenerValores={(valores) => {
            _f_.asignar(ev_u, { do_filtros: valores });
          }}
        />
      }

      <div className="ventaEnTiendaCSS-cuerpo">
        <_tabla_.Tabla
          origen={origenComponente}
          cabecera={v_u.do_datosTabla.headgrid}
          registros={v_u.do_datosTabla.grid}
          filtros={v_u.do_filtros}
          modoVista={"modo2"}
          permiteMultiseleccion={v_u.multiseleccion}
          permiteOpciones={true}
          opcionesPorDefecto={0b00_000_011}
          camposCodigosSeleccion={["codigo"]}
          campoCodigoCategoria={"categoria"}
          campoCodigoRegistrosPorCategoria={"registros"}
          campoOpcionesTablaInterna={"opcionesTablaInterna"}
          datosComplementarios={{
            codigoPrecioVenta: v_u.d_codigoPrecioDeVenta,
            ...v_u.do_datosTabla,
          }}
          reglasDeEstadoRegistros={v_u.do_datosTabla.reglasDeEstadoRegistros}
          mapaDeEventos={{
            formulario: _form_.Formulario,
            0b1: _form_.Formulario,
            0b010_000_000: _form_.Formulario,
          }}
          campoCodigoDespliegaDetalleRegistro={"codCategoria"}
          permiteDespliegueInferiorPorRegistro={false}
          permiteDetalleAlTocarElemento={true}
          fObtenerSeleccionados={(seleccionados) => {
            _f_.asignar(ev_u, { do_seleccionados: seleccionados });
          }}
          fNotificarActualizacionDeTabla={(actualizar) => {
            if (actualizar) {
              _f_.asignar(ev_u, { d_actualizarTabla: !v_u.d_actualizarTabla });
            }
          }}
          fObtenerDatosParcialesActualizados={(datos) => {
            console.log(datos);
            _f_.asignar(ev_u, { d_totalEntrega: datos?.TotalEntrega });
          }}
          fObtenerEstadoProcesando = {(estado)=>{
            // console.log("esta procesando la tabla:",estado)
            _f_.asignar(ev_u,{d_esperandoProcesoTabla:estado})
          }}
        />
      </div>
      <_txta_.TextArea
        texto="ingrese un comentario"
        estilos={{ anchoTA: "100%"}}
        onChange={(evento) => {
          // console.log(evento.target.value);
          _f_.asignar(ev_u, { d_comentario: evento.target.value });
        }}
      />
      <div className="ventaEnTiendaCSS-opciones">
        <_btn_.Boton
          texto="Emitir Boleta"
          tipo="btn-2"
          estilos={{ color: "var(--color_amarillo_1)", anchoB2: "10rem", colorFuenteB2: "black" }}
          disabled={v_u.d_esperandoProcesoTabla}
          onClick={() => {
            console.log("click");
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "Boleta de Venta",
              modal_estilos: { anchoMI: "30rem" },
            });
            _f_.asignar(ev_u, { d_tipoComprobante: "BOLETA", d_codigoComprobante: 1 });
          }}
        />
        <_btn_.Boton
          texto="Emitir Factura"
          disabled={v_u.d_esperandoProcesoTabla}
          tipo="btn-2"
          estilos={{ color: "#4e942e", anchoB2: "10rem" }}
          onClick={() => {
            console.log("click");
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "Factura Electrónica",
              modal_estilos: { anchoMI: "30rem" },
            });
            _f_.asignar(ev_u, { d_tipoComprobante: "FACTURA", d_codigoComprobante: 2 });
          }}
        />
      </div>
    </div>
  );
}
export default VentaEnTienda;
